import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import type { OtroTramiteRecord } from '../../types';

interface ConfirmDeleteDialogProps {
  open: boolean;
  tramite: OtroTramiteRecord;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
  error?: string | null;
}

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  tramite,
  onOpenChange,
  onConfirm,
  isDeleting,
  error,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[80dvh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Eliminar trámite</DialogTitle>
        <DialogDescription>
          Esta acción no se puede deshacer. Se eliminará el trámite {tramite.id} y sus datos asociados.
        </DialogDescription>
      </DialogHeader>

      <p className="text-sm text-gray-600">
        Confirmá si querés eliminar el trámite de {tramite.otorgantes.map(o => o.nombre).join(', ')}. Recordá que esta operación es permanente.
      </p>

      {error && <p className="text-sm text-rose-600">{error}</p>}

      <DialogFooter className="gap-3">
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button type="button" variant="destructive" loading={isDeleting} disabled={isDeleting} onClick={onConfirm}>
          Eliminar
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
